module.exports = __webpack_public_path__ + "static/dealers-of-lightning-27fae2b7f4b6ff0321805bac7e1373fc.jpg";